import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendEbDeviceProgressStepper from "./components/amendEbDeviceProgressStepper"
import CoreEbDeviceDetails from "./formPages/coreEbDeviceDetails"
import ReviewAndSubmitEbDevice from "./formPages/reviewAndSubmitEbDevice"
import { AmendEbDeviceContext } from "./providers/baseProviders/amendEbDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for amending an Electric Boiler device */
const AmendEbDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendEbDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendEbDeviceContext}>
            <CoreEbDeviceDetails context={AmendEbDeviceContext} />
            <LctDeviceAttachments<HpDeviceFormData>
                context={AmendEbDeviceContext}
                dataset={Datasets.EB}
                isAmendment
            />
            <ReviewAndSubmitEbDevice
                context={AmendEbDeviceContext}
                isAmendment
            />
        </MultiPageForm>
    </Stack>
)

export default AmendEbDeviceForm
